<div [attr.class]="'booking-total ' + (classList ? 'booking-total--' + classList : '')">
  <ng-container *ngIf="!dataFetched">
    <div [attr.class]="'booking-total__order ' + (classList ? 'booking-total__order--' + classList : '')">
      <app-loading-placeholder [type]="placeholderTypes.bookingTotal" [loopArray]="[1, 2]" />
    </div>
    <div
      class="booking-total__sum"
      [attr.class]="'booking-total__sum ' + (classList ? 'booking-total__sum--' + classList : '')"
    >
      <app-loading-placeholder [type]="placeholderTypes.bookingTotal" [loopArray]="[1]" />
    </div>
  </ng-container>
  <ng-container *ngIf="dataFetched">
    <div *ngIf="!isOfferExist" class="booking-total__no-offers">
      {{ 'no-offer' | translate }}
    </div>
    <div *ngIf="isOfferExist || confirmationDataLoaded" class="booking-total__order">
      <h6 class="booking-total__order-title">{{ 'checkout-price-details-title' | translate }}</h6>
      <div [attr.class]="'booking-total__item ' + (classList ? 'booking-total__item--' + classList : '')">
        <span class="booking-total__item-label">
          {{ daysCount }}
          {{ daysCount <= 1 ? ('booking-widget-night' | translate) : ('booking-widget-nights' | translate) }}
          <ng-container *ngIf="isExtension">{{ 'booking-widget-extension' | translate }}</ng-container>
        </span>
        <span class="booking-total__item-value">
          {{ currency | translate }}{{ applicableCosts?.net.amount | number }}
        </span>
      </div>
      <div class="booking-total__item">
        <span class="booking-total__item-label">
          {{ 'checkout.price-details.vat' | translate }}
        </span>
        <span class="booking-total__item-value">
          {{ currency | translate }}{{ applicableCosts?.tax.amount | number }}
        </span>
      </div>
    </div>
    <div *ngIf="isOfferExist || confirmationDataLoaded" class="booking-total__sum">
      <div class="booking-total__item">
        <span class="booking-total__item-label">
          {{ 'booking-widget-total' | translate }}
        </span>
        <span class="booking-total__item-value">
          <ng-container *ngIf="ratePlan?.noVoucherTotalGrossAmount">
            <span class="booking-total__item-value--old"
              >{{ currency | translate
              }}<span class="booking-total__old-amount">{{
                ratePlan?.noVoucherTotalGrossAmount?.amount | number
              }}</span></span
            >
          </ng-container>
          {{ currency | translate
          }}<span class="booking-total__amount">{{
            confirmationDataLoaded ? confirmationTotal : (ratePlan?.totalGrossAmount.amount | number)
          }}</span>
        </span>
      </div>
    </div>
  </ng-container>
</div>
